import { render, staticRenderFns } from "./DunningRecovered.vue?vue&type=template&id=15ec3d06&"
import script from "./DunningRecovered.vue?vue&type=script&lang=js&"
export * from "./DunningRecovered.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports